import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type DialogConfirmData = {
  header?: string;
  title?: string;
  description?: string;
  itemName?: string;
  confirmText?: string;
  cancelText?: string;
  intent?: 'danger' | 'success';
};

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
})
export class DialogConfirmComponent {
  header: string;
  title: string;
  description?: string;
  itemName?: string;
  confirmText: string;
  cancelText: string;
  intent: 'danger' | 'success';

  constructor(
    private dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmData
  ) {
    this.header = data?.header || '';
    this.title = data?.title || 'Tem certeza que deseja confirmar esta ação?';
    this.description = data?.description;
    this.itemName = data?.itemName;
    this.confirmText = data?.confirmText || 'Confirmar';
    this.cancelText = data?.cancelText || 'Voltar';
    this.intent = data?.intent || 'danger';
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
